var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main",style:(_vm.styleObj)},[_vm._t("default"),(_vm.isDisablePage)?_c('div',{staticClass:"mask"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }